module.exports = __webpack_public_path__ + "media/images/admin/icons/toggle-left-6fc22f8668f3e7e2913f3d9e605fe24a.svg";